/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import viewicoSvg from '../../../../public/view-product.svg';
import editicoSvg from '../../../../public/edit-product.svg';
class PractitionersProducts extends React.Component {
  render() {

    return (
      <div className="container pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Practitioner's Products</li>
          </ol>
        </nav>
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-md-10 head-title">
            <h4>Dr Vivek’s Naturopathy, <span className="linear-title">Products</span></h4>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <Link to="/create-event" className="btn theme-btn-fill">
              <i className="fa fa-plus-circle" aria-hidden="true"></i> Add New Product
            </Link>
          </div>
          <hr></hr>
          <div className="col-12">
            <div className="row">
              <span className="text-secondary d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Products
              </span>
              <div className="col-4">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input type="text" className="form-control pd-tb-675em" name="searchname" placeholder="Search By Name" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <label for="eventname" className="form-label over-label2">Date of Event</label>
                  <input type="text" className="form-control pd-tb-675em" name="eventdate" placeholder="mm/dd/yyyy" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <select className="form-select pd-tb-675em" aria-label="Search Domain">
                    <option value="" selected disabled>Search By Domain</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
          <div className="col-md-10 mb-4">
            <div className="fw-normal show-count"><b>Showing 8 of 23 Products</b></div>
          </div>
          <div className="col-md-2 view-mode-btn text-end mb-3">
            <a href="#" className="btn" id="list2"> <i className="fa fa-list p-2 fs-4" aria-hidden="true"></i></a>
            <a href="#" className="btn active_btn2" id="grid2"> <i className="fa fa-th p-2 fs-4" aria-hidden="true"></i></a>
          </div>
          <div className="col-12">
            <div className="row view-group" id="products2">
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-1.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-2.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-3.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-4.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-5.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-6.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-7.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3 item item2">
                <div className="card p-3 product-card thumbnail">
                  <div className="img-event">
                    <img src={require('../../../../public/product-img-8.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                  </div>
                  <div className="card-img-overlay">
                    <a href="#" className="btn">
                      <img src={viewicoSvg} alt="view product" />
                    </a>
                    <a href="#" className="btn d-block">
                      <img src={editicoSvg} alt="edit product" />
                    </a>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title">My Product Name
                      <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                    <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                    <figure className="bg-white p-2 mt-3 pro-cap">
                      <blockquote className="blockquote pb-2 card-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                      </blockquote></figure>
                    <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2">
                      <small className="text-muted fw-normal">
                        <b>Added -</b> Sept, 2022</small>
                      <small className="text-muted fw-normal mx-1"> <b>Last Updated -</b> Jan, 2023</small>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default PractitionersProducts;